// dependencies

// style
import styles from "./css/NotFound.module.css"


const NotFound = () => {

    return (
        <div className={styles.container}>
            <div className={styles.card}>
                <h1 className={styles.title}>This page doesn't exist :{"("}</h1>
            </div>
        </div>
    )
}

export default NotFound
